import LocalizedStrings from "react-localization";
import LocalText from "src/local";

const localizationStrings = new LocalizedStrings({
  ja: {
    label: LocalText.screens.authPasswordReset.requestLayout.label,
    inputEmailPlaceholder:
      LocalText.screens.authPasswordReset.requestLayout.inputEmailPlaceholder,
    inputEmailValidationRequire:
      LocalText.screens.authPasswordReset.requestLayout
        .inputEmailValidationRequire,
    inputEmailValidationFormat:
      LocalText.screens.authPasswordReset.requestLayout
        .inputEmailValidationFormat,
    btnReset: LocalText.screens.authPasswordReset.requestLayout.btnReset,
  },
});

export { localizationStrings };
